
import { ReactNode } from 'react'
import styles from './styles.module.scss'

interface BackgroundModal {
  children: ReactNode 
  isModalOpen: boolean
}


export function BackgroundModal({ children, isModalOpen }: BackgroundModal) {

  return (
    <div className={`${styles.backgroundModal} ${isModalOpen && styles.show}`}>]
      {children}
    </div>
  )
}
